<template>
    <div class="flex serviceContent mobileFlex" :class="items[id].corpNoClass">
        <div class="leftContent">
            <figure class="usedServiceImgBox">
                <img :src="items[id].Image" alt="source img">
                <figcaption>
                    {{ items[id].caption }}
                </figcaption>
            </figure>
        </div>
        <div class="rightContent">
            <p>
                <strong>
                    {{ items[id].contentTitle }}
                </strong>
            </p>
            <p :class="items[id].sClass">
                {{ items[id].contents }}
            </p>
        </div>
    </div>
</template>

<script>

export default {
    props : [
        'id',
    ],
    data() {
        return {
            items: [
                {
                    id:0,
                    corpNoClass: 'corpNoClass01',
                    Image: require("../../../assets/images/cmmnMain/UsedService/회원가입.png"),
                    //caption: '회원가입',
                    contentTitle: '간단한 회원가입을 통해 다양한 기업들을 만나볼 수 있는 기회를 얻으십시오.',
                    contents: '회원가입을 완료하셨다면 귀하께서 작성한 정보를 확인한 후 관리자로 부터 승인메일을 전송받으실 예정입니다. 승인절차 이후에 서비스를 이용이 가능하며, 제공하신 정보가 틀릴 경우 이용이 일부 제한될 수 있습니다.'
                },
                {
                    id:1,
                    corpNoClass: 'corpNoClass02',
                    Image: require("../../../assets/images/cmmnMain/UsedService/프로필작성.png"),
                    //caption: '프로필 작성',
                    contentTitle: '다른 기업들이게 보여질 소중한 기업정보를 입력해주시기 바랍니다.',
                    contents: '매치메이킹 서비스를 이용하시기 위해서는 프로필 작성을 완료해 주셔야 합니다. 다른 기업회원들과의 원활한 매칭을 위해 입력하신 정보가 맞는지 확인해 주시길 바랍니다. 프로필 미완성시 서비스 이용이 일부 제한될 수 있습니다.'
                },
                {
                    id:2,
                    corpNoClass: 'corpNoClass03',
                    Image: require("../../../assets/images/cmmnMain/UsedService/기업검색.png"),
                    //caption: '기업 검색',
                    contentTitle: '다양한 시니어산업 또는 관심 기업들을 찾아보십시오.',
                    contents: '기업의 미충족 수요(unmet needs)를 해결하고 목표(goal) 달성에 필요한 기업을 추천해 드립니다. 추천 서비스 이외에도 검색필터를 통해 원하는 기업을 직접 검색해보실 수 있습니다.'
                },
                {
                    id:3,
                    corpNoClass: 'corpNoClass04',
                    Image: require("../../../assets/images/cmmnMain/UsedService/직접매칭.png"),
                    //caption: '직접 매칭',
                    contentTitle: '검색필터를 이용해 네트워킹하고 싶은 기업을 찾아 직접 매칭을 신청해보십시오.',
                    contents: '원하는 기업을 찾으셨다면 상대방에게 전달하고 싶은 내용을 매칭신청서에 작성해서 보내십시오. 상대기업의 매칭 승인이 완료되명 매칭이 성사됩니다.'
                },
                {
                    id:4,
                    corpNoClass: 'corpNoClass05',
                    Image: require("../../../assets/images/cmmnMain/UsedService/뉴에이징플랫폼자문.png"),
                    //caption: '뉴에이징 플랫폼 자문',
                    contentTitle: '선택한 기업이 적합한지 AgeTech Platform에서 의견 또는 자문을 드립니다.',
                    contents: '기업의 미충족 수요(unmet needs)와 목표(goal) 달성에 보다 나은 선택을 할 수 있도록 기업에 대해 시니어산업 전문가의 의견 또는 자문을 제공해드립니다. (*메치메이킹 의견 및 자문은 선택사항입니다.)'
                },
                {
                    id:5,
                    corpNoClass: 'corpNoClass06',
                    Image: require("../../../assets/images/cmmnMain/UsedService/기업네트워킹.png"),
                    //caption: '기업 네트워킹',
                    contentTitle: '선택한 기업과 매칭이 이루어졌다면 자유롭게 상대 기업과 비즈니스 네트워킹을 해보십시오.',
                    contents: '상대 기업으로부터 매치메이킹 승인이 완료되면 네트워킹을 위한 해당 기업의 연락처가 공개됩니다.'
                },
                {
                    id:6,
                    corpNoClass: 'corpNoClass07',
                    Image: require("../../../assets/images/cmmnMain/UsedService/결과공유.png"),
                    //caption: '결과 공유',
                    contentTitle: '매치메이킹 경험을 AgeTech Platform에 공유해 주십시오.',
                    contents: '직접 매치메이킹을 한 경우 AgeTech Platform에 경험을 공유해주십시오. (*공유해주신 내용은 개인정보처리방침에 따라 철저히 관리됩니다.)'
                },
                {
                    id:6,
                    corpNoClass: 'corpNoClass08',
                    Image: require("../../../assets/images/cmmnMain/UsedService/서비스제공.png"),
                    //caption: '서비스 제공',
                    contentTitle: 'AgeTech Platform의 시니어산업 분야별 전문가 멘토링 서비스를 제공합니다.',
                    contents: '다양한 분야의 뉴에이징 멘토들을 만나 비즈니스 문제를 해결해보십시오. 멘토링 서비스 이외에도 에이지테크연구소에서 시니어산업 비즈니스 실증, 연구, 정책 연계, 교육 서비스를 제공합니다. (*전문가 멘토링은 선택사항이며, 이용시 미팅일정 및 장소 조율을 위한 관리자와의 협의가 필요합니다.)',
                    sClass: 'paddingControl'
                }
            ]
        }
    }
}
</script>
